/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import PropTypes from "prop-types";
import Dropzone from 'react-dropzone';
import {Select, RadioCheckGroup, Label} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import {OM3P} from '../../../../constants/constants';
import TextInput from "../../../../widgets/TextInput/TextInput";


export default class Om3pModal extends React.Component {

    static get propTypes() {
        return {
            activeCollection: PropTypes.object.isRequired,
            uploadFile: PropTypes.func,
            resourceUploadData: PropTypes.object.isRequired,
            updateAdditionalResourceInfo: PropTypes.func.isRequired,
            resourceUploadSuccessDataEdit: PropTypes.func.isRequired,
            clearAdditionalInfo: PropTypes.func,
            closeModal: PropTypes.func.isRequired,
            getResource: PropTypes.func,
            resourceInfo: PropTypes.object,
            editModal: PropTypes.bool,
            clearResource: PropTypes.func,
            resource: PropTypes.object
        };
    }

    constructor(props) {
        super(props);
        this.state ={
            successObj: {
                title: '',
                firstName: '',
                lastName: '',
                haveRights: true,
                contentType : 'Textbook',
                insertAfter : 0,
                trimSize : '',
                type : 'Original Material(OM)',
                resourceColorSetting: 'Color',
                description: ''
            },
            errorObj: {
                title: null,
                firstName: null,
                lastName: null
            },
            fileName : '',
            uploadStatus: '*PDF Only'
        };
        this.upload = this.upload.bind(this);
        this.addButtonClick = this.addButtonClick.bind(this);
        this.updateState = this.updateState.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.saveButtonClick =this.saveButtonClick.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if(this.props.editModal) {
            if (nextProps.resourceUploadData.successData.resourceId !== this.props.resourceUploadData.successData.resourceId) {
                const successObj = this.state.successObj;
                const fName = nextProps.resourceUploadData.successData.authors.split(" ")[0];
                const lName = nextProps.resourceUploadData.successData.authors.split(" ")[1];
                successObj[OM3P.TITLE] = nextProps.resourceUploadData.successData.title;
                successObj[OM3P.CONTENT_TYPE] = nextProps.resourceUploadData.successData.category;
                successObj[OM3P.FIRST_NAME] = fName;
                successObj[OM3P.LAST_NAME] = lName;
                successObj[OM3P.TYPE] = nextProps.resourceUploadData.successData.pearsonResourceType === OM3P.RIGHTS_OM ? OM3P.ORIGINAL_MATERIAL : OM3P.THIRD_PARTY;
                successObj[OM3P.TRIM_SIZE] = nextProps.resourceUploadData.successData.trimSize.name;
                successObj[OM3P.COLOR] = nextProps.resourceUploadData.successData.resourceColorSetting === OM3P.FOUR_COLOR ? OM3P.FOUR_COLOR : OM3P.BLACK_WHITE;
                successObj[OM3P.DESCRIPTION] = nextProps.resourceUploadData.successData.description;
                this.setState({
                    successObj: successObj
                });
            }
        }
    }

    componentWillMount(){
        if(this.props.editModal) {
            let options = {
                resourceId: this.props.resourceInfo.resource,
                currency: this.props.activeCollection.geo.code,
                priceType: this.props.activeCollection.collectionType
            };
            this.props.getResource(options);
        }
    }
    componentWillUnmount(){
        this.props.clearResource();
    }
    onDrop = (collectionId, file) => {
        this.upload(file);
    };

    upload(files) {
        const formData = new FormData();
        formData.append("file", files[0]);
        this.setState({
            fileName: files[0].name,
            uploadStatus: 'Uploading...'
        });
        const params = {
            collectionId : this.props.activeCollection.collectionId,
            orientation : this.props.activeCollection.trimSize.orientation,
            collectionType : this.props.activeCollection.collectionType,
            unscrubbed : this.props.activeCollection.unscrubbed
        };
        this.props.uploadFile(params, formData);
    }

    updateState(attribute, value, callBack){
        const successObj = this.state.successObj;
        successObj[attribute] = value;
        this.setState({
            successObj: successObj
        }, callBack);
    }
    handleChange(e){
        this.updateState(e.target.id, e.target.value);
    }
    addButtonClick(){
        const reqBody = {...this.state.successObj};
        reqBody.authors = this.state.successObj.firstName + ' ' + this.state.successObj.lastName;
        reqBody.cccSearchDTO = {...this.props.resourceUploadData.successData.cccSearchDTO};
        reqBody.cccSearchDTO.primaryAuthorName = reqBody.authors;
        reqBody.cccSearchDTO[OM3P.SUB_TITLE] = this.state.successObj[OM3P.TITLE];
        let resourceColorSetting = null;
        if (this.state.successObj.resourceColorSetting === OM3P.FOUR_COLOR) {
            resourceColorSetting = OM3P.FOUR_COLOR;
        } else {
            resourceColorSetting = OM3P.SINGLE_COLOR;
        }
        reqBody.pearsonResourceType = OM3P.RIGHTS_OM;
        reqBody.resourceColorSetting = resourceColorSetting;
        reqBody.cccSearchDTO[OM3P.ESTIMATED_USERS_COUNT] ? reqBody[OM3P.ESTIMATED_USERS_COUNT] = reqBody.cccSearchDTO[OM3P.ESTIMATED_USERS_COUNT] :
            reqBody[OM3P.ESTIMATED_USERS_COUNT] = this.props.resourceUploadData.successData[OM3P.ESTIMATED_USERS_COUNT];
        reqBody.cccSearchDTO[OM3P.ISBN] ? reqBody[OM3P.ISBN] = reqBody.cccSearchDTO[OM3P.ISBN] :
            reqBody[OM3P.ISBN] = this.props.resourceUploadData.successData[OM3P.ISBN];
        delete reqBody[OM3P.TRIM_SIZE];
        delete reqBody[OM3P.TYPE];
        delete reqBody[OM3P.INSERT_AFTER];
        delete reqBody[OM3P.CONTENT_TYPE];
        const resourceUploadData = this.props.resourceUploadData;

        if (resourceUploadData) {
            const init = {...resourceUploadData.init};
            init[OM3P.INSERT_AFTER] = this.state.successObj.insertAfter-1;
            reqBody.init = init;
            const options = {
                collectionId: this.props.activeCollection.collectionId,
                resourceId: resourceUploadData.resourceId
            };
            this.props.updateAdditionalResourceInfo(options, reqBody);
        }
    }
    saveButtonClick(){
        const reqBody = this.state.successObj;
        reqBody.authors = this.state.successObj.firstName + ' ' + this.state.successObj.lastName;
        reqBody.cccSearchDTO = {...this.props.resourceUploadData.successData.cccSearchDTO};
        reqBody.cccSearchDTO.primaryAuthorName = reqBody.authors;
        reqBody.cccSearchDTO[OM3P.SUB_TITLE] = this.state.successObj[OM3P.TITLE];
        let pearsonResourceType = null;
        let resourceColorSetting = null;
        if (this.state.successObj.type === OM3P.ORIGINAL_MATERIAL){
            pearsonResourceType = OM3P.RIGHTS_OM;
        } else {
            pearsonResourceType = OM3P.RIGHTS_3P;
            reqBody.cccSearchDTO[OM3P.ESTIMATED_USERS_COUNT] ? reqBody[OM3P.ESTIMATED_USERS_COUNT] = reqBody.cccSearchDTO[OM3P.ESTIMATED_USERS_COUNT] :
                reqBody[OM3P.ESTIMATED_USERS_COUNT] = this.props.resourceUploadData.successData[OM3P.ESTIMATED_USERS_COUNT];
            reqBody.cccSearchDTO[OM3P.ISBN] ? reqBody[OM3P.ISBN] = reqBody.cccSearchDTO[OM3P.ISBN] :
                reqBody[OM3P.ISBN] = this.props.resourceUploadData.successData[OM3P.ISBN];
        }
        if (this.state.successObj.resourceColorSetting === OM3P.FOUR_COLOR) {
            resourceColorSetting = OM3P.FOUR_COLOR;
        } else {
            resourceColorSetting = OM3P.SINGLE_COLOR;
        }
        reqBody.pearsonResourceType = pearsonResourceType;
        reqBody.resourceColorSetting = resourceColorSetting;
        delete reqBody[OM3P.TRIM_SIZE];
        delete reqBody[OM3P.TYPE];
        delete reqBody[OM3P.INSERT_AFTER];
        delete reqBody[OM3P.CONTENT_TYPE];
        if (this.props.resourceUploadData.successData) {
            const options = {
                collectionId: this.props.activeCollection.collectionId,
                resourceId: this.props.resourceUploadData.successData.resourceId
            };
            this.props.updateAdditionalResourceInfo(options, reqBody);
        }
    }
    hideModal(){
        this.props.closeModal();
    }
    render() {
        let {successObj} = this.state;
        return <div>
            <div className="om-3p-modal-content">
                {(!this.props.editModal || this.props.resourceUploadData.successData.resourceId)
                    ? <div className={successObj.type === OM3P.THIRD_PARTY ? 'om-shrink': ''}>
                        <form className="pe-form">
                            {!this.props.editModal
                        && <div>
                            <div className="child-container">
                                <label className="pe-textLabelInput__label">File</label>
                                <input className="pe-textInput--basic file-name" type="text" id="file-name"
                                    value={this.state.fileName} disabled={true}/>
                            </div>
                            < div className="child-container">
                                <Dropzone className = "pe-btn" accept="pdf"
                                    onDrop = {this.onDrop}>Choose File
                                </Dropzone>
                                <label className="pe-label">{!this.props.resourceUploadData.resourceId ? this.state.uploadStatus : '*PDF Only'}</label>
                            </div>
                        </div>}
                            <div className="child-container">
                                <TextInput className="title" labelText="Title" type="text" id="title" value={successObj.title}
                                    onChange={this.handleChange}/>
                            </div>
                            <div className="child-container">
                                {(!this.props.editModal || successObj.type !== '') &&<Select id="type"
                                    labelText="Type"
                                    changeHandler={this.handleChange}
                                    options={[OM3P.ORIGINAL_MATERIAL]}
                                    selectedOption= {successObj.type}
                                />}
                            </div>
                            <div className="child-container">
                                {(!this.props.editModal || successObj.contentType !== '') && <Select id="content_type"
                                    labelText="Content Type"
                                    changeHandler={this.handleChange}
                                    options={["Textbook"]}
                                    selectedOption= {successObj.contentType}
                                />}
                            </div>
                            <div className="child-container">
                                <TextInput id="firstName" labelText="Author First Name" value={successObj.firstName} onChange={this.handleChange}/>
                            </div>
                            <div className="child-container">
                                <TextInput id="lastName" labelText="Author Last Name" value={successObj.lastName} onChange={this.handleChange}/>
                            </div>
                            <div className="child-container">
                                {(!this.props.editModal || successObj.trimSize !== '') && <Select id="trim_size"
                                    labelText="Trim Size"
                                    changeHandler={this.handleChange}
                                    options={["6 x 9","8.5 x 11","10 x 8.5"]}
                                    selectedOption= {successObj.trimSize}
                                    inputState={this.props.editModal ? "disabled" : ''}
                                />}
                            </div>
                            <div className="child-container">
                                {(!this.props.editModal || successObj.resourceColorSetting !== '') && <Select id="resourceColorSetting"
                                    labelText="Color"
                                    changeHandler={this.handleChange}
                                    options={["Color","Black and White"]}
                                    selectedOption= {successObj.resourceColorSetting}
                                />}
                            </div>
                            <div className="child-container">
                                <label className="pe-textLabelInput__label" htmlFor="description">Description</label>
                                <textarea id="description" className="pe-multiLineText description" value={successObj.description}
                                    onChange={this.handleChange} ></textarea>
                            </div>
                        </form>
                    </div>:<div className="loader"></div>
                }

            </div>
            <div className="modal-footer">
                {!this.props.editModal && <div className="insert-after-container">
                    <label className="pe-label">Insert after :</label>
                    <input className="pe-textInput--basic" id="insertAfter" value={successObj.insertAfter} onChange={this.handleChange}/>
                </div> }
                <button type="button" className="pe-btn--btn_large close-modal" onClick={this.hideModal}>Close</button>
                <button type="submit" className="pe-btn__primary--btn_large add-om-3pm"
                    onClick={this.props.editModal? this.saveButtonClick : this.addButtonClick}
                    disabled={successObj.title === ""
                    || (this.props.resourceUploadData.resourceId || this.props.resourceUploadData.successData.resourceId) === undefined} >
                    {this.props.editModal ? 'Save' : 'Add'}</button>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/OM3PComponents/Om3pModal.js